<template>
  <transition name="toast">
    <div class="toaster" :class="{'toast--error': isError}">
      {{text}}
      <div v-if="!!error" class="font-body-small toast__dev" >
        <p v-if="error.fileName">{{error.fileName}} : {{error.lineNumber}}</p>
        <p>
          {{
            error.response
            ? `${error.response.status}: ${JSON.stringify(error.response.data)}`
            : error.message
          }}
        </p>
      </div>
      <close-button
        @close="dismiss"
        class="toast__close-button"
        :color="isError ? 'sapphire' : 'white'"
      />
    </div>
  </transition>
</template>

<script>
import CloseButton from '@components/buttons/close-button.vue';

export default {
  components: {
    CloseButton,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    error: {
      type: [Error, String, Boolean],
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeoutId: undefined,
    };
  },
  mounted() {
    this.timeoutId = setTimeout(this.dismiss, 5000);
  },
  beforeUnmount() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    dismiss() {
      this.$store.dispatch('notifications/removeToastNotification', this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.toaster {
  position: relative;
  display: inline-block;
  padding: calc(var(--grid-unit) * 1.5);
  margin-bottom: calc(var(--grid-unit) / 2);
  color: var(--gray-0);
  background: var(--sapphire-500);
  border-radius: var(--radius-big);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  opacity: 1;

  @media screen and (max-width: 470px) {
    margin-left: var(--grid-unit);
    margin-right: var(--grid-unit);
  }

  &--error {
    color: var(--rust-80);
    background: var(--rust-10);
  }

  &__dev {
    margin-top: var(--grid-unit);
  }

  &__close-button {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.toast-enter-active,
.toast-leave-active {
  transition: transform 0.5s, opacity 0.5s;
}

.toast-enter-to,
.toast-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
</style>
